import { ChangeEvent, ChangeEventHandler, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import NodeStore from '../../stores/NodeStore';
import InputOutputNode, { Data } from './base-nodes/InputOutputNode';
import { optionNode, captureResponseNode, emailNode, imageNode, promptNode, questionNode, yesNoNode } from '../../config/node-types';
import { IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const handleStyle = { left: 10 };

type Props = {
    data: {
        value: string,
        isAction: boolean
        showAfter: boolean,
        isFunction: boolean,
        functionId: string,
        functionName: string
    },
    isConnectable: boolean,
    id: string
}

const config = {
    name: 'Function',
    color: "Gray",
    nodeType: 'functionNode',
    inputs: [
        /*promptNode,        */
    ],
    outputs: [
        //{ ...questionNode, outputColor: '#66FF00' },
        //promptNode,                
        //{ ...emailNode, outputColor: '#43C6DB' },
        //{ ...imageNode, inputColor: '#66FF00' },
        //{ ...answerNode, outputColor: 'green' }
    ]
} as Data

function FunctionNode({ data, isConnectable, id }: Props) {
    const onTextAreaChange = useCallback((evt: ChangeEvent<HTMLTextAreaElement>) => {
        NodeStore.update((s, o) => {
            const temp = structuredClone(o.chat);

            const node = temp.nodes.find(s => s.id === id);

            if (node) {
                node.data.value = evt.target.value;
            }
            localStorage.setItem('nodes', JSON.stringify(temp));
            s.isDirty = true;
            s.chat = temp;
        });
    }, []);


    return (
        <InputOutputNode data={config} selected={false} nodeId={id} hidePrompts>
            <div className='main' style={{ display: 'flex', color: 'back', justifyContent: 'space-between', alignItems: 'center', gap: 5, padding: 5 }}>
                <Typography sx={{ color: 'black' }} variant='subtitle1'>{data.functionName}</Typography>
                <a href={`/chatbot/admin/chat/${data.functionId}` } target="_blank">
                    <IconButton title='Edit Function' sx={{ cursor: 'pointer' }} >
                        <EditIcon color='primary' />
                    </IconButton>
                </a>
            </div>
        </InputOutputNode>
    )
}

export default FunctionNode;